if (!customElements.get('finch-product-layout')) {
  customElements.define(
    'finch-product-layout',
    class FinchProductLayout extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.mobileMedia = window.matchMedia('(max-width: 989px)');
        this.handleBreakpointChange = () => this.schedulePlaceItems();
        this.handleSectionLoad = (event) => {
          if (event.target === this || event.target?.contains?.(this)) {
            this.schedulePlaceItems();
          }
        };
        this.mobileMedia.addEventListener('change', this.handleBreakpointChange);
        document.addEventListener('shopify:section:load', this.handleSectionLoad);

        if (window.Shopify?.designMode) {
          this.editorObserver = new MutationObserver(() => this.schedulePlaceItems());
          this.editorObserver.observe(this, {
            attributes: true,
            subtree: true,
            attributeFilter: [
              'data-fp-desktop-area',
              'data-fp-desktop-order',
              'data-fp-mobile-order',
              'data-fp-source-order',
              'data-fp-use-custom-mobile-order',
            ],
          });
        }

        this.placeItems();
      }

      disconnectedCallback() {
        this.mobileMedia?.removeEventListener('change', this.handleBreakpointChange);
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);
        this.editorObserver?.disconnect();
        if (this.placeItemsFrame) cancelAnimationFrame(this.placeItemsFrame);
        this.placeItemsFrame = null;
        this.initialized = false;
      }

      schedulePlaceItems() {
        if (this.placeItemsFrame) return;

        this.placeItemsFrame = requestAnimationFrame(() => {
          this.placeItemsFrame = null;
          if (this.isConnected) this.placeItems();
        });
      }

      placeItems() {
        const items = Array.from(this.querySelectorAll('[data-fp-layout-item]'));
        const isMobile = this.mobileMedia.matches;
        const groups = new Map();

        items.forEach((item, sourceIndex) => {
          if (!item.hasAttribute('data-fp-source-index')) {
            item.dataset.fpSourceIndex = String(sourceIndex);
          }

          if (item.matches('[data-fp-hide-when-empty]') && item.childElementCount === 0) {
            item.hidden = true;
            return;
          }

          const slotName = isMobile ? 'mobile' : item.dataset.fpDesktopArea || 'right';
          const sourceOrder = Number.parseInt(item.dataset.fpSourceOrder, 10);
          const fallbackSourceIndex = Number(item.dataset.fpSourceIndex);
          const stableSourceOrder = Number.isFinite(sourceOrder)
            ? sourceOrder
            : fallbackSourceIndex;
          const useCustomMobileOrder =
            item.dataset.fpUseCustomMobileOrder === 'true';
          const configuredOrder = Number(
            isMobile ? item.dataset.fpMobileOrder : item.dataset.fpDesktopOrder
          );
          const order =
            isMobile && !useCustomMobileOrder
              ? stableSourceOrder
              : configuredOrder;
          const group = groups.get(slotName) || [];

          group.push({
            item,
            order: Number.isFinite(order) ? order : 50,
            sourceIndex: stableSourceOrder,
          });
          groups.set(slotName, group);
        });

        groups.forEach((group, slotName) => {
          const slot = this.querySelector(`[data-fp-layout-slot="${slotName}"]`);
          if (!slot) return;

          group
            .sort(
              (first, second) =>
                first.order - second.order || first.sourceIndex - second.sourceIndex
            )
            .forEach(({ item }, index) => {
              const reference = slot.children[index] || null;
              if (reference === item) return;

              if (typeof slot.moveBefore === 'function') {
                try {
                  slot.moveBefore(item, reference);
                  return;
                } catch (_error) {
                  // Fall back to the widely supported DOM insertion path.
                }
              }

              slot.insertBefore(item, reference);
            });
        });

        ['left', 'right'].forEach((slotName) => {
          const slot = this.querySelector(`[data-fp-layout-slot="${slotName}"]`);
          slot
            ?.closest('.fp__column')
            ?.classList.toggle('fp__column--has-content', slot.childElementCount > 0);
        });
      }
    }
  );
}
